import { render, staticRenderFns } from "./AddEditContactsAndSocials.vue?vue&type=template&id=66b4b838"
import script from "./AddEditContactsAndSocials.vue?vue&type=script&lang=js"
export * from "./AddEditContactsAndSocials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports